import { defineMessage } from 'services/localization';

export const messages = {
    setOnHold: defineMessage('set_on_hold'),
    returnToApproval: defineMessage('return_to_approval'),
    setOnHoldPopupTitle: defineMessage('reason_to_put_the_request_on_hold'),
    returnToApprovalPopupTitle: defineMessage('reason_to_return_the_request_on_approval'),
    save: defineMessage('save'),
    comment: defineMessage('comment'),
};
